import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { EP2_quest1Data, EP2_quest1Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F29.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame29() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest1 = useSelector(EP2_quest1Data);

        return (
            <div className="F29_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F29_entryBox">
                    <div className="F29_heading">
                        {
                            language === 'english' ?
                                <p className="F29_headingEnglish">Why periods only happen to girls? What do you think her teacher’s response should be?</p>
                                :
                                <p className="F29_headingUrdu">ماہواری صرف لڑکیوں کو ہی کیوں ہوتی ہے؟ آپ کے خیال میں اسکی ٹیچر کا کیا جواب ہونا چاہیئے۔</p>
                        }
                    </div>
                    <div className="F29_options">
                        <div onClick={() => { dispatch(EP2_quest1Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F29_option" : "F29_optionUrdu"}>
                            {language === 'english' ? `A. ${quest1.headingEnglish.A}` : `${quest1.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(EP2_quest1Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F29_option" : "F29_optionUrdu"}>
                            {language === 'english' ? `B. ${quest1.headingEnglish.B}` : `${quest1.headingUrdu.B}`}
                        </div>
                        
                    </div>

                    <div className="F29_timeline">
                        <div className='F29_timelineBar'>
                            <div className='F29_timelineFill'></div>
                            <span className='F29_timelineText'>6/19</span>
                        </div>
                    </div>

                    <div className="F29_nextFrames">
                        <div className="F29_nextFrame1"></div>
                        <div className="F29_nextFrame2"></div>
                        <div className="F29_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
}

export default Frame29;